import { useState } from "react";
import { FetchResult, gql, useMutation } from "@apollo/client";
import { useToast } from "@/hooks/use-toast";

const UPLOAD_DOCUMENT_MUTATION = gql`
  mutation UploadContactDocument(
    $contactId: Long
    $fileName: String
    $data: Base64String
    $tags: String
  ) {
    uploadDocumentInContext(
      fileName: $fileName
      data: $data
      context: "1"
      id: $contactId
      tags: $tags
    )
  }
`;

interface uploadDocumentQueryVariables {
  contactId: number;
  fileName: string;
  data: string;
  tags: string;
}

interface uploadDocumentQueryResponse {
  uploadDocumentInContext: boolean;
}

export const useUploadDocument = () => {
  const [uploading, setUploading] = useState(false);
  const { toast } = useToast();
  const [handleUploadDocument] = useMutation<
    uploadDocumentQueryResponse,
    uploadDocumentQueryVariables
  >(UPLOAD_DOCUMENT_MUTATION);

  const uploadDocument = async (
    contactId: number,
    fileName: string,
    data: string,
    tags: string,
    callback?: () => void
  ) => {
    setUploading(true);
    try {
      const apiResponse = await handleUploadDocument({
        variables: { contactId, fileName, data, tags },
      });
      handleBadAPIResponse(apiResponse);
      setUploading(false);
      callback && callback();
      return apiResponse;
    } catch (e: unknown) {
      toast({
        title: "Error uploading document",
        description: "An error occurred while uploading document",
        variant: "destructive",
      });
      setUploading(false);
      return null;
    }
  };

  return { uploadDocument, uploading };
};

//***:cqcsContactNotes=2024-12-16=testingTesting2

const handleBadAPIResponse = (
  apiResponse: FetchResult<
    uploadDocumentQueryResponse,
    Record<string, unknown>,
    Record<string, unknown>
  >
) => {
  if (!apiResponse.data || !apiResponse.data.uploadDocumentInContext) {
    throw new Error("Error while setting monthly investments");
  }
};
